import type { GameState } from '../engine/state';
import type { HexId } from '../board/axial';
import type { BanditBag } from './bandit';

// The bandit's soft-read seam (plan §5.3): harvest suppresses the bandit's hex WHEN the
// module is composed; with the bandit removed this returns null and suppression simply
// disappears — graceful removal without a hard inter-module dependency.

export function banditHexOf(state: GameState): HexId | null {
  const bag = state.bags['bandit'] as BanditBag | undefined;
  return bag ? bag.hex : null;
}
